import { useCallback, useState } from "react";
import AccordionItem from "../AccordionItem/AccordionItem";
import styles from './Accordion.module.scss';


const Accordion = ({ accordionData }) => {
    const [collapse, setCollapse] = useState();

    const accordionHendler = useCallback((index) => {
        setCollapse(prevCollapse => index === prevCollapse ? null : index);
    }, []);

    return (
        <ul className={styles.container}>
            {accordionData.map((element, index) => {
                return (
                    <AccordionItem
                        onClick={() => accordionHendler(index)}
                        element={element}                       
                        isOpen={index === collapse}
                        key={index}
                    />
                )
            })}
        </ul>
    );
};

export default Accordion;